// Converts an image into pure white
//
// CSS filters are not supported in IE11,
// So we use canvas approach only for IE11
VP = window.VP || {};

(function( $ ) {
	var SELECTOR = '.js-white-image';
	VP.whiteImage = {
		init: function () {
			var _this = this;

			if ( ! /(MSIE|Trident)/i.test(navigator.userAgent) ) {
				return;
			}

			$( SELECTOR ).each(function () {
				_this.colorizeImage( this );
			});
		},

		colorizeImage: function ( imageElement ) {
			var img = new Image();
			img.onload = function() {
				// create hidden canvas (using image dimensions)
				var canvas = document.createElement("canvas");
				canvas.width = imageElement.offsetWidth;
				canvas.height = imageElement.offsetHeight;

				var ctx = canvas.getContext("2d");
				ctx.drawImage(imageElement,0,0,canvas.width,canvas.height);

				var map = ctx.getImageData(0,0,canvas.width,canvas.height);
				var imdata = map.data;

				// convert image to grayscale
				var r,g,b,avg;
				for(var p = 0, len = imdata.length; p < len; p+=4) {
					r = 255;
					g = 255;
					b = 255;
					// alpha channel (p+3) is ignored

					avg = Math.floor((r+g+b)/3);

					imdata[p] = imdata[p+1] = imdata[p+2] = avg;
				}

				ctx.putImageData(map,0,0);

				// replace image source with canvas data
				imageElement.src = canvas.toDataURL();
			};
		    img.src = imageElement.src;
		}
	};
})(jQuery);
